import { EntityType } from '@frontend/common';
import { LockerClient } from '@frontend/locker/api';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useLocker:request': CustomEvent<string>;
    }
}

const REQUEST_LOCKER_EVENT = 'useLocker:request';
const STORAGE_KEY = 'LCK_REQ';

export function lockerRequest(lockerId: string) {
    window.dispatchEvent(new CustomEvent(REQUEST_LOCKER_EVENT, { detail: lockerId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function LockerResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_LOCKER_EVENT, EntityType.LOCKER, (ids) => LockerClient.resolveLockers(ids), props.dispatch);
    return <></>;
}
